module.exports = __webpack_public_path__ + "media/assets/fonts/Montserrat-Bold-a6bc51efd33e2f7f1b95d90fcb6d5991.otf";